import { useParams } from 'react-router-dom';

import { ACCOUNT_SETTINGS } from 'constants/paths';
import { t } from 'i18next';

type ErrorMessageData = {
  text: string;
  heading: string;
  button: {
    btnText: string;
    path: string;
  };
};

const MessagesData: Record<number | string, ErrorMessageData> = {
  404: {
    heading: t('pageNotFound'),
    text: t('pageNotFoundBody'),
    button: {
      btnText: t('goToMyAccount'),
      path: ACCOUNT_SETTINGS,
    },
  },
  default: {
    heading: t('unknownError'),
    text: t('unknownErrorBody'),
    button: {
      btnText: t('goToMyAccount'),
      path: ACCOUNT_SETTINGS,
    },
  },
} as const;

function isAvailableCodeNumber(code?: string): code is string {
  return !!code && Object.keys(MessagesData).includes(code);
}

export function useErrorToMessageData(): ErrorMessageData {
  const { code } = useParams();
  return MessagesData[isAvailableCodeNumber(code) ? code : 'default'];
}
